import Flag from '../Flag';

/** Horizontal Annotation flag */
export default class HorizontalAnnotationFlag extends Flag {
	_getStyle(args = {}) {
		const returnStyle = this.panel.core.getStyle('flag.horizontalAnnotation');
		const panelStyle = this.panel.params.style;
		const indicatorStyle = this.indicator ? this.indicator.params.style : {};

		// Use indicator color if it exists
		if (indicatorStyle.color) returnStyle.background.color = indicatorStyle.color;

		// Use fallback values if necessary
		if (!returnStyle.font.family) returnStyle.font.family = panelStyle.yAxis.font.family;
		if (!returnStyle.font.size) returnStyle.font.size = panelStyle.yAxis.font.size;

		return {
			...returnStyle,
			...args.style
		};
	}

	/**
	 * Private method to get flag value
	 * @return {number}
	 * @override
	 * @private
	 */
	getValue() {
		let value;

		if (this.panel.isNormalized) {
			value = this.panel.actualToNormalized(
				this.indicator.handle[0].params.value
			);
		} else if (this.indicator.handle) {
			value = this.indicator.handle[0].params.value;
		}

		if (!this.panel) return null;

		return value;
	}

	/**
	 * @returns The appropriate event emitter types
	 * @type {object}
	 */
	get eventType() {
		return {
			render: 'FLAG_RENDER_HORIZ_ANNOTATION',
			hide: 'FLAG_HIDE_HORIZ_ANNOTATION',
			show: 'FLAG_SHOW_HORIZ_ANNOTATION'
		};
	}
}
